<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18.067 18.067"
    aria-hidden="true"
    fill="currentColor"
  >
    <path
      d="M9.029.2a8.833 8.833 0 1 0 8.838 8.833A8.827 8.827 0 0 0 9.029.2Zm6.117 5.3H12.54a14.032 14.032 0 0 0-1.219-3.145A7.074 7.074 0 0 1 15.146 5.5ZM9.033 2a12.233 12.233 0 0 1 1.687 3.5H7.346A12.233 12.233 0 0 1 9.033 2ZM2.2 10.8a6.91 6.91 0 0 1 0-3.533h2.978a14.529 14.529 0 0 0-.119 1.767 13.69 13.69 0 0 0 .123 1.766Zm.72 1.767h2.602a14.149 14.149 0 0 0 1.219 3.149 7.082 7.082 0 0 1-3.825-3.149ZM5.522 5.5H2.916a7.082 7.082 0 0 1 3.825-3.149A14.149 14.149 0 0 0 5.522 5.5Zm3.511 10.569a12.469 12.469 0 0 1-1.687-3.5h3.374a12.469 12.469 0 0 1-1.687 3.5ZM11.1 10.8H6.966a12.274 12.274 0 0 1-.141-1.767 12.274 12.274 0 0 1 .141-1.767H11.1a12.274 12.274 0 0 1 .141 1.767A12.274 12.274 0 0 1 11.1 10.8Zm.225 4.911a14.114 14.114 0 0 0 1.219-3.145h2.606a7.105 7.105 0 0 1-3.825 3.145Zm1.56-4.911a14.526 14.526 0 0 0 .124-1.767 13.69 13.69 0 0 0-.124-1.767h2.981a7.071 7.071 0 0 1 .234 1.767 6.873 6.873 0 0 1-.234 1.767Z"
    />
  </svg>
</template>
